import { useEffect, useState } from "react";
import API_ROUTES from "~/api-routes";
import apiService from "~/services/service";
import z from "zod";

export const REQUEST_TYPES = {
  AD_HOC: "AD_HOC",
  ESCALATION: "ESCALATION",
};

const useRequest = (requestType) => {
  const type = ["all", "sent", "received"];
  const [activeIndex, setActiveIndex] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(10);
  const [isDataAvailable, setIsDataAvailable] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [requests, setRequest] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [count, setCount] = useState({
    all: 0,
    sent: 0,
    received: 0,
  });

  const fetchRequests = async ({ pageIndex = page, pageSize = rows } = {}) => {
    setLoading(true);
    setIsDataAvailable(true);
    const { data } = await apiService(API_ROUTES.FETCH_REQUESTS, "GET", {
      replace: {
        page: pageIndex + 1,
        pageSize,
        filter: type[activeIndex],
        requestType,
      },
      schema: z.object({
        page: z.number().optional(),
        pageSize: z.number().optional(),
        filter: z.string().optional(),
        requestType: z.string(),
      }),
    });
    const requestList = data?.requests || [];
    if (activeIndex === 0) {
      setTotalRecords(data?.total_all_requests || 0);
    } else if (activeIndex === 1) {
      setTotalRecords(data?.total_sent_requests || 0);
    } else if (activeIndex === 2) {
      setTotalRecords(data?.total_received_requests || 0);
    }
    setCount({
      all: data?.total_all_requests,
      sent: data?.total_sent_requests,
      received: data?.total_received_requests,
    });
    if (requestList.length) {
      setRequest(requestList);
      setIsDataAvailable(true);
    } else {
      setRequest([]);
      setIsDataAvailable(false);
    }
    setLoading(false);
  };
  const onPageChange = (e) => {
    setPage(e.page);
    setRows(e.rows);
    fetchRequests({ pageIndex: e.page, pageSize: e.rows });
  };
  useEffect(() => {
    setPage(0);
    setRows(10);
    setTotalRecords(0);
    fetchRequests({ pageIndex: 0, pageSize: 10 });
  }, [activeIndex]);
  const hideRequestModal = () => {
    setShowModal(false);
  };
  const refetch = async () => {
    setShowModal(false);
    await fetchRequests({ pageIndex: 0, pageSize: 10 });
  };
  return {
    activeIndex,
    setActiveIndex,
    loading,
    setLoading,
    page,
    setPage,
    rows,
    setRows,
    isDataAvailable,
    setIsDataAvailable,
    totalRecords,
    setTotalRecords,
    requests,
    setRequest,
    fetchRequests,
    onPageChange,
    count,
    showModal,
    setShowModal,
    hideRequestModal,
    refetch,
  };
};

export default useRequest;
